export default {
  api: {
    ssl: true,
    domain:  API_SERVER,
    id: 'zzzRRDtest',
    published: true,
    getUrl() {
      return `${this.ssl ? 'https://' : 'http://'}${this.domain}/oauthserver/`;
    }
  },
};
 
  